import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

interface SignaturePadProps {
  onSignatureChange: (signatureData: string) => void;
  error?: string;
}

export const SignaturePad: React.FC<SignaturePadProps> = ({
  onSignatureChange,
  error,
}) => {
  const signatureCanvasRef = useRef<SignatureCanvas>(null);

  const handleClear = () => {
    if (signatureCanvasRef.current) {
      signatureCanvasRef.current.clear();
      onSignatureChange('');
    }
  };

  const handleEnd = () => {
    if (signatureCanvasRef.current && !signatureCanvasRef.current.isEmpty()) {
      const signatureData = signatureCanvasRef.current.toDataURL('image/png');
      onSignatureChange(signatureData);
    }
  };

  const borderClass = error ? 'border-red-500' : 'border-[#E8A87C]';

  return (
    <div className="w-full">
      <label className="block text-right mb-3">
        <span className="text-sm font-semibold text-[#1B4332]">חתימה דיגיטלית</span>
        <span className="text-red-500 mr-1">*</span>
      </label>
      <div className={`border-2 rounded-lg overflow-hidden bg-white ${borderClass}`}>
        <SignatureCanvas
          ref={signatureCanvasRef}
          canvasProps={{
            width: 500,
            height: 200,
            className: 'w-full touch-none',
          }}
          onEnd={handleEnd}
          penColor="#1B4332"
          backgroundColor="#FFFFFF"
        />
      </div>
      {error && <p className="text-red-500 text-sm mt-2 text-right">{error}</p>}
      <button
        type="button"
        onClick={handleClear}
        className="mt-3 px-4 py-2 bg-[#F5F0E8] text-[#1B4332] rounded-lg hover:bg-[#E8D9C8] transition-colors duration-200 text-sm font-medium"
      >
        נקה חתימה
      </button>
    </div>
  );
};
